<htc-dialog
  [showPopup]="(debugService.showDebugMenu | async) ?? false"
  [useBackground]="true"
  [useWideMode]="false"
  title="Debug Menu"
  (showPopupChange)="onPopupChange($event)">
  <div class="body">
    <div
      class="flex-container flex-row flex-justify-space-between debug-menu-tabs">
      <input
        type="radio"
        id="feature-flags"
        name="debug-tabs"
        [checked]="currentView === debugView.FEATURE_FLAGS"
        (click)="setView(debugView.FEATURE_FLAGS)" />
      <label for="feature-flags">
        <svg-icon
          class="debug-icon"
          [src]="
            'helix/app-assets/htec/button-icons/flag.svg' | cdnSrcBaseUrl: true
          "></svg-icon>
        <p class="debug-text">Feature Flags</p>
      </label>
      <input
        type="radio"
        id="video-settings"
        name="debug-tabs"
        [checked]="currentView === debugView.AUDIO_VIDEO_SETTINGS"
        (click)="setView(debugView.AUDIO_VIDEO_SETTINGS)" />
      <label for="video-settings">
        <svg-icon
          class="debug-icon"
          [src]="
            'helix/app-assets/htec/button-icons/skip-next.svg'
              | cdnSrcBaseUrl: true
          "></svg-icon>
        <p class="debug-text">Audio/Video</p>
      </label>
      <input
        type="radio"
        id="kb-debug"
        name="debug-tabs"
        [checked]="currentView === debugView.KB_DEBUG"
        (click)="setView(debugView.KB_DEBUG)" />
      <label for="kb-debug">
        <svg-icon
          class="debug-icon"
          [src]="
            'helix/app-assets/htec/button-icons/knowledge-base.svg'
              | cdnSrcBaseUrl: true
          "></svg-icon>
        <p class="debug-text">KB Debug</p>
      </label>

      <input
        type="radio"
        id="clickstream-debug"
        name="Clickstream Debug"
        [checked]="currentView === debugView.CLICKSTREAM_DEBUG"
        (click)="setView(debugView.CLICKSTREAM_DEBUG)" />
      <label for="clickstream-debug">
        <svg-icon
          class="debug-icon"
          [src]="
            'helix/app-assets/htec/button-icons/knowledge-base.svg'
              | cdnSrcBaseUrl: true
          "></svg-icon>
        <p class="debug-text">Clickstream Debug</p>
      </label>

      <input
        type="radio"
        id="save-data-importer"
        name="debug-tabs"
        [checked]="currentView === debugView.SAVE_DATA_IMPORT_EXPORT"
        (click)="setView(debugView.SAVE_DATA_IMPORT_EXPORT)" />
      <label for="save-data-importer">
        <svg-icon
          class="debug-icon"
          [src]="
            'helix/app-assets/htec/button-icons/import-export.svg'
              | cdnSrcBaseUrl: true
          "></svg-icon>
        <p class="debug-text">Save Data Importer</p>
      </label>
      <input
        type="radio"
        id="save-data-editor"
        name="debug-tabs"
        [checked]="currentView === debugView.SAVE_DATA_EDITOR"
        (click)="setView(debugView.SAVE_DATA_EDITOR)" />
      <label for="save-data-editor">
        <svg-icon
          class="debug-icon"
          [src]="
            'helix/app-assets/htec/button-icons/edit.svg' | cdnSrcBaseUrl: true
          "></svg-icon>
        <p class="debug-text">Save Data Editor</p>
      </label>

      <input
        type="radio"
        id="message-debug"
        name="debug-tabs"
        [checked]="currentView === debugView.MESSAGES_DEBUG"
        (click)="setView(debugView.MESSAGES_DEBUG)" />
      <label for="message-debug">
        <svg-icon
          class="debug-icon"
          [src]="
            'helix/app-assets/htec/button-icons/import-export.svg'
              | cdnSrcBaseUrl: true
          "></svg-icon>
        <p class="debug-text">Messages Debug</p>
      </label>
    </div>

    <div class="debug-content">
      @switch (currentView) {
        @case (debugView.AUDIO_VIDEO_SETTINGS) {
          <div @fadeInOut>
            <!-- Video Section -->
            <div class="debug-section">
              <h3 class="debug-section-title">Video Settings</h3>
              <htc-button-with-icon
                (click)="setVideoFinished()"
                classes="btn btn-watched-video btn-with-left-icon"
                [imagePath]="
                  'helix/app-assets/htec/button-icons/skip-next.svg'
                    | cdnSrcBaseUrl: true
                "
                btnText="Set Watched Video"></htc-button-with-icon>
            </div>
            <!-- Phoneme Video Section -->
            <div class="debug-section">
              <h3 class="debug-section-title">Video Tools</h3>
              <div class="phoneme-selectors-row">
                <!-- English Phoneme Video Selector -->
                <div class="phoneme-selector">
                  <label for="video-phoneme" class="phoneme-label"
                    >Phoneme Video (English):</label
                  >
                  <div class="phoneme-controls">
                    <select
                      id="video-phoneme"
                      class="phoneme-select"
                      [(ngModel)]="selectedVideoPhoneme"
                      [compareWith]="comparePhonemes">
                      <option [ngValue]="undefined">Select a phoneme...</option>
                      @for (phoneme of englishPhonemes; track phoneme) {
                        <option [ngValue]="phoneme">
                          {{ phoneme.phoneme }} ({{ phoneme.filename }})
                        </option>
                      }
                    </select>
                    <htc-button-with-icon
                      (btnClicked)="loadPhonemeVideo()"
                      classes="btn btn-with-left-icon"
                      imagePath="/assets/read-aloud/audioPlayerPlay.svg"
                      btnText="Load Video"
                      [enable]="!!selectedVideoPhoneme"></htc-button-with-icon>
                  </div>
                </div>
                <!-- Word Part Video Selector -->
                <div class="phoneme-selector">
                  <label for="video-word-part" class="phoneme-label"
                    >Word Part Video:</label
                  >
                  <div class="phoneme-controls">
                    <select
                      id="video-word-part"
                      class="phoneme-select"
                      [(ngModel)]="selectedVideoWordPart"
                      [compareWith]="comparePhonemes">
                      <option [ngValue]="undefined">
                        Select a word part...
                      </option>
                      @for (wordPart of wordParts; track wordPart) {
                        <option [ngValue]="wordPart">
                          {{ wordPart.phoneme }} ({{ wordPart.filename }})
                        </option>
                      }
                    </select>
                    <htc-button-with-icon
                      (btnClicked)="loadWordPartVideo()"
                      classes="btn btn-with-left-icon"
                      imagePath="/assets/read-aloud/audioPlayerPlay.svg"
                      btnText="Load Video"
                      [enable]="!!selectedVideoWordPart"></htc-button-with-icon>
                  </div>
                </div>
              </div>
              <!-- Video Player -->
              @if (currentVideoUrl) {
                <div class="video-container">
                  <!-- Error Message -->
                  @if (videoError) {
                    <div class="video-error">
                      <p>{{ videoError }}</p>
                    </div>
                  }
                  <!-- Video Player -->
                  @if (!videoError) {
                    <div class="video-and-overlay">
                      @if (!isVideoPlaying || showVideoReplay) {
                        <div
                          class="video-overlay"
                          [ngClass]="{ replay: showVideoReplay }"
                          (click)="onReplayClick()">
                          @if (showVideoReplay) {
                            <svg-icon
                              src="/assets/button-icons/replay.svg"></svg-icon>
                          }
                          @if (!showVideoReplay) {
                            <svg-icon
                              src="/assets/video-control-icons/play.svg"></svg-icon>
                          }
                        </div>
                      }
                      <video
                        id="debug-video"
                        (loadeddata)="onVideoLoaded()"
                        (play)="onVideoPlay()"
                        (ended)="onVideoEnded()"
                        (error)="onVideoError()"
                        [src]="currentVideoUrl"
                        class="debug-video-player"></video>
                    </div>
                  }
                </div>
              }
            </div>
            <!-- Audio Section -->
            <div class="debug-section">
              <h3 class="debug-section-title">Audio Tools</h3>
              <div class="phoneme-selectors-row">
                <!-- English Phoneme Selector -->
                <div class="phoneme-selector">
                  <label for="english-phoneme" class="phoneme-label"
                    >Phoneme (English):</label
                  >
                  <div class="phoneme-controls">
                    <select
                      id="english-phoneme"
                      class="phoneme-select"
                      [(ngModel)]="selectedEnglishPhoneme"
                      [compareWith]="comparePhonemes">
                      <option [ngValue]="undefined">Select a phoneme...</option>
                      @for (phoneme of englishPhonemes; track phoneme) {
                        <option [ngValue]="phoneme">
                          {{ phoneme.phoneme }} ({{ phoneme.filename }})
                        </option>
                      }
                    </select>
                    <htc-button-with-icon
                      (click)="playEnglishPhoneme()"
                      classes="btn btn-with-left-icon"
                      src="/assets/read-aloud/audioPlayerPlay.svg"
                      btnText="Play"
                      [enable]="
                        !!selectedEnglishPhoneme
                      "></htc-button-with-icon>
                  </div>
                </div>
                <!-- Spanish Phoneme Selector -->
                <div class="phoneme-selector">
                  <label for="spanish-phoneme" class="phoneme-label"
                    >Phoneme (Spanish):</label
                  >
                  <div class="phoneme-controls">
                    <select
                      id="spanish-phoneme"
                      class="phoneme-select"
                      [(ngModel)]="selectedSpanishPhoneme"
                      [compareWith]="comparePhonemes">
                      <option [ngValue]="undefined">Select a phoneme...</option>
                      @for (phoneme of spanishPhonemes; track phoneme) {
                        <option [ngValue]="phoneme">
                          {{ phoneme.phoneme }} ({{ phoneme.filename }})
                        </option>
                      }
                    </select>
                    <htc-button-with-icon
                      (click)="playSpanishPhoneme()"
                      classes="btn btn-with-left-icon"
                      src="/assets/read-aloud/audioPlayerPlay.svg"
                      btnText="Play"
                      [enable]="
                        !!selectedSpanishPhoneme
                      "></htc-button-with-icon>
                  </div>
                </div>
                <!-- Word Parts Selector -->
                <div class="phoneme-selector">
                  <label for="word-part" class="phoneme-label"
                    >Word Part:</label
                  >
                  <div class="phoneme-controls">
                    <select
                      id="word-part"
                      class="phoneme-select"
                      [(ngModel)]="selectedWordPart"
                      [compareWith]="comparePhonemes">
                      <option [ngValue]="undefined">
                        Select a word part...
                      </option>
                      @for (wordPart of wordParts; track wordPart) {
                        <option [ngValue]="wordPart">
                          {{ wordPart.phoneme }} ({{ wordPart.filename }})
                        </option>
                      }
                    </select>
                    <htc-button-with-icon
                      (click)="playWordPart()"
                      classes="btn btn-with-left-icon"
                      src="/assets/read-aloud/audioPlayerPlay.svg"
                      btnText="Play"
                      [enable]="!!selectedWordPart"></htc-button-with-icon>
                  </div>
                </div>
              </div>
              <!-- Phonemic Breakdown Section -->
              @if (isAuthenticationEnabled) {
                <div class="debug-section">
                  <h3 class="debug-section-title">Phonemic Breakdown</h3>
                  <div class="phonemic-breakdown-controls">
                    <div class="text-input-group">
                      <label for="phonemic-text" class="phoneme-label"
                        >Text to analyze:</label
                      >
                      <input
                        id="phonemic-text"
                        type="text"
                        class="phonemic-text-input"
                        [(ngModel)]="phonemicText"
                        placeholder="Enter text for phonemic breakdown..."
                        [disabled]="
                          isGeneratingSequence || isPlayingSequence
                        " />
                    </div>
                    <div class="phonemic-buttons">
                      <htc-button-with-icon
                        (click)="generatePhonemicSequence()"
                        classes="btn btn-with-left-icon"
                        src="/assets/read-aloud/audioPlayerPlay.svg"
                        [btnText]="isGeneratingSequence ? 'Finding...' : 'Find'"
                        [enable]="
                          !!phonemicText.trim() &&
                          !isGeneratingSequence &&
                          !isPlayingSequence
                        "></htc-button-with-icon>
                      <htc-button-with-icon
                        (click)="playFullWord()"
                        classes="btn btn-with-left-icon"
                        src="/assets/read-aloud/audioPlayerPlay.svg"
                        btnText="Play Word"
                        [enable]="
                          !!phonemicText.trim() &&
                          !isGeneratingSequence &&
                          !isPlayingSequence
                        "></htc-button-with-icon>
                      <htc-button-with-icon
                        (click)="playPhonemicSequence()"
                        classes="btn btn-with-left-icon"
                        src="/assets/read-aloud/audioPlayerPlay.svg"
                        [btnText]="
                          isPlayingSequence ? 'Playing...' : 'Play Phonemes'
                        "
                        [enable]="
                          !!generatedAudioSequence && !isPlayingSequence
                        "></htc-button-with-icon>
                    </div>
                    @if (generatedAudioSequence) {
                      <div class="sequence-info">
                        <p class="sequence-details">
                          Generated sequence with
                          {{ generatedAudioSequence.parts.length }} phonemes
                        </p>
                        <div class="phoneme-list">
                          @for (
                            part of generatedAudioSequence.parts;
                            track part;
                            let i = $index
                          ) {
                            <span
                              class="phoneme-item clickable-phoneme"
                              [class.playing-phoneme]="
                                currentlyPlayingPhonemeIndex === i
                              "
                              (click)="playIndividualPhoneme(part)"
                              [title]="'Click to play: ' + part.text">
                              {{ part.text }}
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <div class="debug-section disabled-section">
                  <h3 class="debug-section-title">Phonemic Breakdown</h3>
                  <div class="disabled-message">
                    <p>This feature requires authentication to be enabled.</p>
                    <p>
                      Enable the "Authenticate" feature flag to use phonemic
                      breakdown.
                    </p>
                  </div>
                </div>
              }
              <!-- Custom Sentence with Tokens Section -->
              <div class="debug-section">
                <h3 class="debug-section-title">Custom Sentence with Tokens</h3>
                <div class="phonemic-breakdown-controls">
                  <div class="text-input-group">
                    <label for="custom-token-sentence" class="phoneme-label">
                      Enter sentence (supports ${{ '{' }}PHO_xx | xx{{
                        '}'
                      }}
                      and ${{ '{' }}WORDPART_xxx | xxx{{ '}' }}):
                    </label>
                    <input
                      id="custom-token-sentence"
                      type="text"
                      class="phonemic-text-input"
                      [(ngModel)]="customTokenSentence"
                      placeholder="Type a sentence with tokens..."
                      [disabled]="
                        isCustomTokenLoading || isCustomTokenPlaying
                      " />
                  </div>
                  <div class="phonemic-buttons">
                    <htc-button-with-icon
                      (click)="processCustomTokenSentence()"
                      classes="btn btn-with-left-icon"
                      src="/assets/read-aloud/audioPlayerPlay.svg"
                      [btnText]="
                        isCustomTokenLoading ? 'Processing...' : 'Parse'
                      "
                      [enable]="
                        !!customTokenSentence.trim() &&
                        !isCustomTokenLoading &&
                        !isCustomTokenPlaying
                      "></htc-button-with-icon>
                    <htc-button-with-icon
                      (click)="playCustomTokenAudio()"
                      classes="btn btn-with-left-icon"
                      src="/assets/read-aloud/audioPlayerPlay.svg"
                      [btnText]="isCustomTokenPlaying ? 'Playing...' : 'Play'"
                      [enable]="
                        !!customTokenAudioResult && !isCustomTokenPlaying
                      "></htc-button-with-icon>
                  </div>
                  @if (customTokenError) {
                    <div class="video-error">
                      <p>{{ customTokenError }}</p>
                    </div>
                  }
                  @if (customTokenAudioResult) {
                    <div class="sequence-info">
                      @if (isAudioSequence(customTokenAudioResult)) {
                        @if (customTokenAudioResult; as sequence) {
                          <p class="sequence-details">
                            Sequence with {{ sequence.parts.length }} parts:
                          </p>
                          <div class="phoneme-list">
                            @for (part of sequence.parts; track part) {
                              <span class="phoneme-item" [title]="part.text">
                                {{ part.text }}
                              </span>
                            }
                          </div>
                        }
                      } @else {
                        @if (customTokenAudioResult; as audio) {
                          <p class="sequence-details">
                            @if (!isAudioSequence(audio)) {
                              Single audio: {{ audio.text }}
                            }
                          </p>
                        }
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @case (debugView.FEATURE_FLAGS) {
          <div @fadeInOut>
            <htc-feature-flag-menu></htc-feature-flag-menu>
          </div>
        }
        @case (debugView.KB_DEBUG) {
          <div @fadeInOut>
            <htc-kb-debug-menu></htc-kb-debug-menu>
          </div>
        }
        @case (debugView.CLICKSTREAM_DEBUG) {
          <div @fadeInOut>
            <htc-clickstream-debug-menu></htc-clickstream-debug-menu>
          </div>
        }
        @case (debugView.SAVE_DATA_IMPORT_EXPORT) {
          <div @fadeInOut>
            <htc-incomplete-save-data-export-import></htc-incomplete-save-data-export-import>
          </div>
        }
        @case (debugView.SAVE_DATA_EDITOR) {
          <div @fadeInOut>
            <htc-incomplete-save-data-editor></htc-incomplete-save-data-editor>
          </div>
        }
        @case (debugView.MESSAGES_DEBUG) {
          <div @fadeInOut>
            <htc-messages-debug-menu></htc-messages-debug-menu>
          </div>
        }
      }
    </div>
  </div>
</htc-dialog>
